module.exports = __webpack_public_path__ + "img/businessModelRed3.10cb8656.jpg";